import CacheEnabledApiClient from './CacheEnabledApiClient';

class LabelsAPI extends CacheEnabledApiClient {
  constructor() {
    super('labels', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'label';
  }

  getByAccount(accountId) {
    return axios.get(`/api/v1/accounts/${accountId}/labels`);
  }
}

export default new LabelsAPI();
